import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	subscriptions: {
		data: [],
		error: null,
		loading: false,
		totalCount: 0,
		tableParams: {
			page: 0,
			size: 10,
		},
	},
	createdSubscription: { data: null, error: null, loading: false },
	updateSubscriptionIUGU: { data: null, error: null, loading: false },
	changePlanSubscriptionByIUGU: { data: null, error: null, loading: false },
	// can also be used for purchase data
	subscriptionData: {
		error: null,
		loading: false,
		data: {
			planId: null,
			client: {
				name: null,
				cpf: null,
				email: null,
				phone: null,
				depedent: null,
				baseId: null,
				zone: null,
				deliveryPreference: 'Retirada', // 'Entrega',
				address: null,
				birthdate: null,
				password: null,
			},
			paymentMethod: null,
			creditCard: {
				holderName: null,
				number: null,
				expirationMonth: null,
				expirationYear: null,
				cvv: null,
			},
			creditCardToken: null,
			paramsBeeviral: null,
		},
	},
	subscription: { error: null, loading: false, data: null },
	providerInfo: { error: null, loading: false, data: null },
	activateSubscription: { error: null, loading: false, data: null },
	suspendSubscription: { error: null, loading: false, data: null },
	invoices: {
		data: [],
		error: null,
		loading: false,
		totalCount: 0,
		tableParams: {
			page: 0,
			size: 20,
		},
	},
	subscriptionByClientId: { error: null, loading: false, data: null },
	payInvoiceExternally: { error: null, loading: false, data: null },
	statuses: { error: null, loading: false, data: null },
};

const { actions, reducer } = createSlice({
	name: 'subscriptions',
	initialState,
	reducers: {
		getSubscriptions: (state, { payload }) => {
			const { saveConfig = true, ...restPayload } = payload;
			state.subscriptions = {
				...state.subscriptions,
				...(saveConfig ? { tableParams: restPayload } : {}),
				error: null,
				loading: true,
			};
		},
		getSubscriptionsFailure: (state, { payload }) => {
			state.subscriptions = {
				...state.subscriptions,
				error: payload,
				loading: false,
			};
		},
		getSubscriptionsSuccess: (state, { payload }) => {
			state.subscriptions = {
				...state.subscriptions,
				data: payload.body,
				totalCount: payload.meta.totalCount,
				error: null,
				loading: false,
			};
		},
		resetCreateSubscriptionData: (state) => {
			state.createdSubscription = {
				...initialState.createdSubscription,
			};
		},
		createSubscription: (state, { payload }) => {
			state.createdSubscription = {
				...state.createdSubscription,
				error: null,
				loading: true,
			};
		},
		createSubscriptionFailure: (state, { payload }) => {
			state.createdSubscription = {
				...state.createdSubscription,
				error: payload,
				loading: false,
			};
		},
		createSubscriptionSuccess: (state, { payload }) => {
			state.createdSubscription = {
				...state.createdSubscription,
				data: payload,
				error: null,
				loading: false,
			};
		},
		changePlanSubscriptionByIUGU: (state, { payload }) => {
			state.changePlanSubscriptionByIUGU = {
				...state.changePlanSubscriptionByIUGU,
				error: null,
				loading: true,
			};
		},
		changePlanSubscriptionByIUGUFailure: (state, { payload }) => {
			state.changePlanSubscriptionByIUGU = {
				...state.changePlanSubscriptionByIUGU,
				error: payload,
				loading: false,
			};
		},
		changePlanSubscriptionByIUGUSuccess: (state, { payload }) => {
			state.changePlanSubscriptionByIUGU = {
				...state.changePlanSubscriptionByIUGU,
				data: payload,
				error: null,
				loading: false,
			};
		},
		updateSubscriptionIUGU: (state, { payload }) => {
			state.updateSubscriptionIUGU = {
				...state.updateSubscriptionIUGU,
				error: null,
				loading: true,
			};
		},
		updateSubscriptionIUGUFailure: (state, { payload }) => {
			state.updateSubscriptionIUGU = {
				...state.updateSubscriptionIUGU,
				error: payload,
				loading: false,
			};
		},
		updateSubscriptionIUGUSuccess: (state, { payload }) => {
			state.updateSubscriptionIUGU = {
				...state.updateSubscriptionIUGU,
				data: payload,
				error: null,
				loading: false,
			};
		},
		setSubscriptionData: (state, { payload }) => {
			state.subscriptionData = {
				...state.subscriptionData,
				data: {
					...state.subscriptionData.data,
					...payload,
					client: {
						...state.subscriptionData.data.client,
						...payload.client,
					},
					creditCard: {
						...state.subscriptionData.data.creditCard,
						...payload.creditCard,
					},
				},
				error: null,
				loading: false,
			};
		},
		resetSubscriptionData: (state) => {
			state.subscriptionData = {
				...initialState.subscriptionData,
			};
		},
		getSubscriptionsStatuses: (state, { payload }) => {
			state.statuses = {
				...state.statuses,
				error: null,
				loading: true,
			};
		},
		getSubscriptionsStatusesFailure: (state, { payload }) => {
			state.statuses = {
				...state.statuses,
				error: payload,
				loading: false,
			};
		},
		getSubscriptionsStatusesSuccess: (state, { payload }) => {
			state.statuses = {
				...state.statuses,
				data: payload,
				error: null,
				loading: false,
			};
		},
		getSubscriptionById: (state, { payload }) => {
			state.subscription = {
				...state.subscription,
				error: null,
				loading: true,
			};
		},
		getSubscriptionByIdFailure: (state, { payload }) => {
			state.subscription = {
				...state.subscription,
				error: payload,
				loading: false,
			};
		},
		getSubscriptionByIdSuccess: (state, { payload }) => {
			state.subscription = {
				...state.subscription,
				data: payload,
				error: null,
				loading: false,
			};
		},
		getInvoices: (state, { payload }) => {
			const { saveConfig = true, ...restPayload } = payload;
			state.invoices = {
				...state.invoices,
				...(saveConfig ? { tableParams: restPayload } : {}),
				error: null,
				loading: true,
			};
		},
		getInvoicesFailure: (state, { payload }) => {
			state.invoices = {
				...state.invoices,
				error: payload,
				loading: false,
			};
		},
		getInvoicesSuccess: (state, { payload }) => {
			state.invoices = {
				...state.invoices,
				data: payload.body,
				totalCount: payload.meta.totalCount,
				tableParams: {
					page: payload.meta.page,
					size: payload.meta.size,
				},
				error: null,
				loading: false,
			};
		},
		activateSubscription: (state, { payload }) => {
			state.activateSubscription = {
				...state.activateSubscription,
				error: null,
				loading: true,
			};
		},
		activateSubscriptionFailure: (state, { payload }) => {
			state.activateSubscription = {
				...state.activateSubscription,
				error: payload,
				loading: false,
			};
		},
		activateSubscriptionSuccess: (state, { payload }) => {
			state.activateSubscription = {
				...state.activateSubscription,
				data: payload,
				error: null,
				loading: false,
			};
		},
		suspendSubscription: (state, { payload }) => {
			state.suspendSubscription = {
				...state.suspendSubscription,
				error: null,
				loading: true,
			};
		},
		suspendSubscriptionFailure: (state, { payload }) => {
			state.suspendSubscription = {
				...state.suspendSubscription,
				error: payload,
				loading: false,
			};
		},
		suspendSubscriptionSuccess: (state, { payload }) => {
			state.suspendSubscription = {
				...state.suspendSubscription,
				data: payload,
				error: null,
				loading: false,
			};
		},
		payInvoiceExternally: (state, { payload }) => {
			state.payInvoiceExternally = {
				...state.payInvoiceExternally,
				error: null,
				loading: true,
			};
		},
		payInvoiceExternallyFailure: (state, { payload }) => {
			state.payInvoiceExternally = {
				...state.payInvoiceExternally,
				error: payload,
				loading: false,
			};
		},
		payInvoiceExternallySuccess: (state, { payload }) => {
			state.payInvoiceExternally = {
				...state.payInvoiceExternally,
				data: payload,
				error: null,
				loading: false,
			};
		},
		getSubscriptionProviderinfo: (state, { payload }) => {
			state.providerInfo = {
				...state.providerInfo,
				error: null,
				loading: true,
			};
		},
		getSubscriptionProviderinfoFailure: (state, { payload }) => {
			state.providerInfo = {
				...state.providerInfo,
				error: payload,
				loading: false,
			};
		},
		getSubscriptionProviderinfoSuccess: (state, { payload }) => {
			state.providerInfo = {
				...state.providerInfo,
				data: payload,
				error: null,
				loading: false,
			};
		},
		getSubscriptionByClientId: (state, { payload }) => {
			state.subscriptionByClientId = {
				...state.subscriptionByClientId,
				error: null,
				loading: true,
			};
		},
		getSubscriptionByClientIdFailure: (state, { payload }) => {
			state.subscriptionByClientId = {
				...state.subscriptionByClientId,
				error: payload,
				loading: false,
			};
		},
		getSubscriptionByClientIdSuccess: (state, { payload }) => {
			state.subscriptionByClientId = {
				...state.subscriptionByClientId,
				data: payload,
				error: null,
				loading: false,
			};
		},
		resetSubscriptionByClientId: (state) => {
			state.subscriptionByClientId = {
				...initialState.subscriptionByClientId,
			};
		},
	},
});

export const {
	getSubscriptions,
	getSubscriptionsFailure,
	getSubscriptionsSuccess,
	resetCreateSubscriptionData,
	createSubscription,
	createSubscriptionFailure,
	createSubscriptionSuccess,
	setSubscriptionData,
	resetSubscriptionData,
	getSubscriptionsStatuses,
	getSubscriptionsStatusesFailure,
	getSubscriptionsStatusesSuccess,
	getSubscriptionById,
	getSubscriptionByIdFailure,
	getSubscriptionByIdSuccess,
	getInvoices,
	getInvoicesFailure,
	getInvoicesSuccess,
	activateSubscription,
	activateSubscriptionFailure,
	activateSubscriptionSuccess,
	suspendSubscription,
	suspendSubscriptionFailure,
	suspendSubscriptionSuccess,
	payInvoiceExternally,
	payInvoiceExternallyFailure,
	payInvoiceExternallySuccess,
	getSubscriptionProviderinfo,
	getSubscriptionProviderinfoFailure,
	getSubscriptionProviderinfoSuccess,
	getSubscriptionByClientId,
	getSubscriptionByClientIdFailure,
	getSubscriptionByClientIdSuccess,
	resetSubscriptionByClientId,
	updateSubscriptionIUGU,
	updateSubscriptionIUGUFailure,
	updateSubscriptionIUGUSuccess,
	changePlanSubscriptionByIUGU,
	changePlanSubscriptionByIUGUFailure,
	changePlanSubscriptionByIUGUSuccess,
} = actions;

export { default as subscriptionsSaga } from './sagas';

export default reducer;
